var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a-modal",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.visible,
              expression: "visible",
            },
          ],
          attrs: { width: 700, visible: _vm.visible },
          on: { cancel: _vm.handleCancel },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c("a-button", { on: { click: _vm.handleCancel } }, [
                    _vm._v(_vm._s(_vm.$t("message.close"))),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("div", { staticStyle: { display: "flex", gap: "10px" } }, [
            _c(
              "div",
              [
                _c("SupsisIcon", {
                  staticStyle: { width: "50px", height: "50px" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", [
              _c("div", { staticClass: "ant-modal-title" }, [
                _vm._v("What's New"),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "New features, bug fixes, and content you might've missed."
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "news-modal-body" },
            _vm._l(_vm.newsItems, function (item, index) {
              return _c("ItemNewsModal", {
                key: index,
                attrs: {
                  title: item.title,
                  ticket: item.ticket,
                  description: item.description,
                  newsLink: item.newsLink,
                  date: item.date,
                  linkText: item.linkText,
                  ribbonText: item.ribbonText,
                  "on-click": item.onClick,
                  "on-clicked": _vm.handleCancel,
                },
              })
            }),
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }